(ns common.widgets.drawer
  (:require ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.util :as util]
            [common.widgets.resize :as resize]
            [uix.core :refer [$ defui]]))

;; Different drawers use the same saved width
(def DRAWER-KEY "drawer-width")

(defui drawer
  [{:keys [open? on-close label label-component actions children sx]}]
  (let [[width set-width] (resize/use-drawer-width {:k DRAWER-KEY
                                                    :min-width 300})]
    ($ Drawer
       {:variant "persistent"
        :anchor "right"
        :data-testid "panel"
        :sx (util/spread-props #js {:position "relative"}
                               (when open?
                                 ;; Widths relative to the parent element need to be set at this level.
                                 ;; And we need to only set them if the drawer is open, or they would
                                 ;; affect the table always.
                                 #js {:width width
                                      ;; Allow shrink, so layout will automatically handle
                                      ;; preventing the sidebar taking too much space.
                                      :flex "0 1 auto"})
                               sx)
        :PaperProps #js {:sx #js {:position "relative"
                                  :overflow "hidden"}}
        :onClose on-close
        :open open?}
       ;; If we add the content to tree when the drawer isn't open, it will always
       ;; take up space in the container flexbox. Right now there is no simple way
       ;; to fix that.
       ;; Because we are removing the content from tree only the appear transition works.
       ;; We'd need to refactor the drawer component more to get animations working correctly
       ;; together with how the sibling (e.g. the table) width is controlled.
       (when open?
         ($ :<>
            ($ resize/resize-handle
               {:width width
                :set-width set-width
                :calculate-width resize/right-side-width
                :sx #js {:left 0}
                :border-sx #js {:left 0}})
            ($ Stack
               {:direction "column"
                :sx #js {:overflow "hidden"
                         :flex 1}}
               ($ Stack
                  {:direction "row"
                   :alignItems "center"
                   :justifyContent "space-between"
                   :gap 1
                   :sx #js {:overflow "hidden"
                            :flexShrink 0
                            :pt 2
                            :px 2}}
                  (cond
                    label-component label-component
                    label ($ Typography
                             {:variant "h1"
                              :noWrap true
                              :sx #js {:pl 1}}
                             label))

                  ($ IconButton
                     {:onClick on-close
                      :data-testid "closeButton"}
                     ($ Icon
                        {:sx #js {:color "grey.40"}}
                        "close")))
               (when actions
                 ($ Stack
                    {:direction "row"
                     :spacing 0.5
                     :sx #js {:px 3 :py 1}}
                    actions))

               ($ Stack
                  {:gap 2
                   :sx #js {:p 3
                            :overflowY "auto"
                            :flex 1}}
                  children)))))))
